import { useContext } from 'react';
import { AgentChatPanelContext } from '../AgentChatPanelContext';

/**
 * Returns the AgentChatPanel context.
 * Safe to call during HMR and provides default values if outside provider.
 * Note: actionBus property can be null on mobile devices.
 */
export function useAgentChatPanelContext() {
  return useContext(AgentChatPanelContext);
}
